import React from "react";
import { motion } from "framer-motion";
import { productProcess } from "../Data";

const ProductProcess = ({subheading,heading,desc}) => {

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 35,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <>
      <section className="journey-section container">

        {/* SUBHEADING */}

        <motion.h3
          className="section-subheading"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
        >
          {subheading}
        </motion.h3>

        {/* HEADING */}

        <motion.h2
          className="section-heading"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
        >
         {heading}
        </motion.h2>

        {/* DESC */}

        <motion.p
          className="section-text"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
        >
        {desc}
        </motion.p>

        {/* GRID */}

        <motion.div
          className="product-process-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.15,
              },
            },
          }}
        >

          {productProcess.map((item, index) => (

            <motion.div
              key={index}
              className="country-process-card"
              variants={fadeUp}
              whileHover={{
                y: -8,
              }}
              transition={{
                duration: 0.3,
              }}
            >

               <p className="process-step section-text">
                  {item.step}
                </p>
<div className="process-row">
              <div className="process-icon-wrapper">
              <motion.img
                src={item.img}
                alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}
                whileHover={{
                  scale: 1.08,
                  rotate: 2,
                }}
                transition={{
                  duration: 0.4,
                }}
              />
              </div>

                <div className="process-content">
                <h3 className="card-heading">
                  {item.title}
                </h3>

                <p className="section-text">
                  {item.desc}
                </p>
                </div>
                </div>

            </motion.div>

          ))}

        </motion.div>

      </section>
    </>
  );
};

export default ProductProcess;